import React, { Component } from 'react';
import './App.css';
import { observer, inject } from 'mobx-react';

import { Layout, Spin } from 'antd';
import { withRouter } from 'react-router-dom';

import ContentRouter from './ContentRouter';

import { api } from '../../services';
import { CheckingAuthentication } from 'air-checking-authentication';
import K from '../../constants';

//NOTE: I added @withRouter decorator because --> https://github.com/mobxjs/mobx-react/issues/210

@withRouter
@inject('translationsStore', 'authStore', 'communicationsStore', 'commonStore')
@observer
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  afterTokenLoadings = () => {
    const { authStore } = this.props;

    api('currentUser').then(user => {
      authStore.setUser(user);
    });
   
    this.pollingInterval = setInterval(() => {
        this.onPollingInterval();
      }, 30000);
      this.onPollingInterval();
  };

  componentDidMount = () => {
    this.setState({ loading: true });
    api('currentUser').then(user => {
      //recupero le info dell'utente corrente...
      this.props.authStore.setToken(user.signInUserSession.idToken.jwtToken);

      this.setState({ loading: false });

      this.props.authStore.setUser(user);

      if (this.props.idToken) {
        this.props.authStore.setToken(this.props.idToken);
        console.log('componentDidMount: new token has been set');
        this.afterTokenLoadings();
      }

      api('dealer profile').then(dealer => {
        this.props.commonStore.setDealer(dealer);
      });
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.idToken !== prevProps.idToken) {
      this.props.authStore.setToken(this.props.idToken);
      console.log('componentDidUpdate: new token has been set');
      if (!prevProps.idToken) {
        this.afterTokenLoadings();
      }
    }
    if (this.props.isauthenticated !== prevProps.isauthenticated) {
      this.props.authStore.setIsLoggedIn(this.props.isauthenticated);
    }
  }

  componentWillUnmount = () => {
    clearInterval(this.pollingInterval);
  };

  onPollingInterval = () => {
    const { communicationsStore } = this.props;
    communicationsStore.load();
  };

  render() {
    const { translationsStore } = this.props;
    return (
      <Layout style={{ minHeight: '100%' }} className="App">
        {this.props.authStore.token && <ContentRouter />}
        <Spin tip={translationsStore.translate('spin.loadingUserInfo')} spinning={this.state.loading} />
      </Layout>
    );
  }
}

export default CheckingAuthentication({ region: K.AWS_AUTH_REGION, userPoolId: K.AWS_AUTH_USER_POOL_ID, userPoolWebClientId: K.AWS_AUTH_USER_POOL_WEBCLIENT_ID })(App);
